export default "__VITE_ASSET__ac8d02bb__"